var _symbol, _symbol2, _symbol3, _path, _path2, _path3, _symbol4, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 0,
    height: 0,
    className: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "descripcion",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3327 10.0003C18.3327 5.39795 14.6017 1.66699 9.99935 1.66699C5.39698 1.66699 1.66602 5.39795 1.66602 10.0003C1.66602 14.6027 5.39698 18.3337 9.99935 18.3337C14.6017 18.3337 18.3327 14.6027 18.3327 10.0003Z",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 13.959V9.79232",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 6.04232C10.4596 6.04232 10.8327 6.41541 10.8327 6.87565C10.8327 7.33589 10.4596 7.70898 9.99935 7.70898C9.53911 7.70898 9.16602 7.33589 9.16602 6.87565C9.16602 6.41541 9.53911 6.04232 9.99935 6.04232Z"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "hoteles",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 3.66732L3.75 18.084C3.75 18.2221 3.86193 18.334 4 18.334H16C16.1381 18.334 16.25 18.2221 16.25 18.084V3.66732C16.25 2.56275 15.3546 1.66732 14.25 1.66732H5.75C4.64543 1.66732 3.75 2.56275 3.75 3.66732Z",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33398 18.3333V15.5C8.33398 15.2239 8.55784 15 8.83398 15H11.1673C11.4435 15 11.6673 15.2239 11.6673 15.5V18.3333",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.45898 4.36732V5.63398C6.45898 5.74444 6.54853 5.83398 6.65898 5.83398H8.34232C8.45277 5.83398 8.54232 5.74444 8.54232 5.63398V4.36732C8.54232 4.25686 8.45277 4.16732 8.34232 4.16732H6.65898C6.54853 4.16732 6.45898 4.25686 6.45898 4.36732Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.45898 7.70033V8.96699C6.45898 9.07745 6.54853 9.16699 6.65898 9.16699H8.34232C8.45277 9.16699 8.54232 9.07745 8.54232 8.96699V7.70033C8.54232 7.58987 8.45277 7.50033 8.34232 7.50033H6.65898C6.54853 7.50033 6.45898 7.58987 6.45898 7.70033Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.45898 11.0333V12.3C6.45898 12.4105 6.54853 12.5 6.65898 12.5H8.34232C8.45277 12.5 8.54232 12.4105 8.54232 12.3V11.0333C8.54232 10.9229 8.45277 10.8333 8.34232 10.8333H6.65898C6.54853 10.8333 6.45898 10.9229 6.45898 11.0333Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.459 4.36732V5.63398C11.459 5.74444 11.5485 5.83398 11.659 5.83398H13.3423C13.4528 5.83398 13.5423 5.74444 13.5423 5.63398V4.36732C13.5423 4.25686 13.4528 4.16732 13.3423 4.16732H11.659C11.5485 4.16732 11.459 4.25686 11.459 4.36732Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.459 7.70033V8.96699C11.459 9.07745 11.5485 9.16699 11.659 9.16699H13.3423C13.4528 9.16699 13.5423 9.07745 13.5423 8.96699V7.70033C13.5423 7.58987 13.4528 7.50033 13.3423 7.50033H11.659C11.5485 7.50033 11.459 7.58987 11.459 7.70033Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.459 11.0333V12.3C11.459 12.4105 11.5485 12.5 11.659 12.5H13.3423C13.4528 12.5 13.5423 12.4105 13.5423 12.3V11.0333C13.5423 10.9229 13.4528 10.8333 13.3423 10.8333H11.659C11.5485 10.8333 11.459 10.9229 11.459 11.0333Z"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "restaurante",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3442 2.6841C12.272 2.16324 11.0682 1.87109 9.7961 1.87109C5.30598 1.87109 1.66602 5.51106 1.66602 10.0012C1.66602 14.4913 5.30598 18.1313 9.7961 18.1313C11.448 18.1313 12.9848 17.6386 14.2676 16.7922",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2355 10.0015C12.2355 8.65449 11.1435 7.5625 9.79645 7.5625C8.44941 7.5625 7.35742 8.65449 7.35742 10.0015C7.35742 11.3486 8.44941 12.4405 9.79645 12.4405C11.1435 12.4405 12.2355 11.3486 12.2355 10.0015Z",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3329 11.6272V5.12313V2.12763C18.3329 1.99405 18.2119 1.89309 18.0805 1.91698V1.91698C15.6373 2.36121 13.8613 4.48914 13.8613 6.97242V10.5318C13.8613 10.7004 13.9692 10.8502 14.1292 10.9035L16.3004 11.6272",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.301 11.627L15.9277 17.5998C15.9097 17.8877 16.1383 18.131 16.4268 18.131H17.8336C18.1097 18.131 18.3336 17.9072 18.3336 17.631V13.795V11.627",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "preguntas",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3327 10.0003C18.3327 5.39795 14.6017 1.66699 9.99935 1.66699C5.39698 1.66699 1.66602 5.39795 1.66602 10.0003C1.66602 14.6027 5.39698 18.3337 9.99935 18.3337C14.6017 18.3337 18.3327 14.6027 18.3327 10.0003Z",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91602 7.2657C8.0284 6.96937 8.19821 6.70376 8.41095 6.48414C8.80054 6.08196 9.33411 5.83398 9.92266 5.83398C11.1156 5.83398 12.0827 6.85278 12.0827 8.10953C12.0827 9.18674 11.3722 10.0891 10.4179 10.325C10.1499 10.3912 9.92266 10.6089 9.92266 10.8851V11.6673",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 15.2086C10.4596 15.2086 10.8327 14.8356 10.8327 14.3753C10.8327 13.9151 10.4596 13.542 9.99935 13.542C9.53911 13.542 9.16602 13.9151 9.16602 14.3753C9.16602 14.8356 9.53911 15.2086 9.99935 15.2086Z"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "place",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 10.1818C20 16.5455 12 22 12 22C12 22 4 16.5455 4 10.1818C4 8.01187 4.84285 5.93079 6.34315 4.3964C7.84344 2.86201 9.87827 2 12 2C14.1217 2 16.1566 2.86201 17.6569 4.3964C19.1571 5.93079 20 8.01187 20 10.1818Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0007 12.9091C13.4734 12.9091 14.6673 11.688 14.6673 10.1818C14.6673 8.67557 13.4734 7.45453 12.0007 7.45453C10.5279 7.45453 9.33398 8.67557 9.33398 10.1818C9.33398 11.688 10.5279 12.9091 12.0007 12.9091Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "filter",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "options/style4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.376 5.00073H17.5033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.50098 5.00073H11.876",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.376 15.0002H17.5033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M2.50098 15.0002H11.876",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8.12598 10.0015H17.501",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M2.50098 10.0015H5.62828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M13.1259 6.25282C13.8168 6.25282 14.3768 5.69276 14.3768 5.0019C14.3768 4.31103 13.8168 3.75098 13.1259 3.75098C12.4351 3.75098 11.875 4.31103 11.875 5.0019C11.875 5.69276 12.4351 6.25282 13.1259 6.25282Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M6.8769 11.2523C7.56776 11.2523 8.12782 10.6923 8.12782 10.0014C8.12782 9.31054 7.56776 8.75049 6.8769 8.75049C6.18603 8.75049 5.62598 9.31054 5.62598 10.0014C5.62598 10.6923 6.18603 11.2523 6.8769 11.2523Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M13.1259 16.2523C13.8168 16.2523 14.3768 15.6923 14.3768 15.0014C14.3768 14.3105 13.8168 13.7505 13.1259 13.7505C12.4351 13.7505 11.875 14.3105 11.875 15.0014C11.875 15.6923 12.4351 16.2523 13.1259 16.2523Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlider);
export default __webpack_public_path__ + "static/media/slider.2acf6b8f3ed50b287c71275fe8455db4.svg";
export { ForwardRef as ReactComponent };